import React, { useState, useEffect } from "react";
import { Modal, Fade, Backdrop } from "@material-ui/core";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import Icon from "components/Icon";
import IconClose from "assets/icons/Close.svg";
import { useTranslation } from "react-i18next";

import {
  POPE_PRAYER_EMBED
} from "../../navigation/CONSTANTS";
import { useStyles } from "./styles";

const is = (path) => new RegExp(path, "i").test(location.pathname);

export function MainModal() {
  const [isOpen, setIsOpen] = useState(false);
  const mediaQueryLg = useMediaQuery("(max-width:1294px)");
  const mediaQueryMd = useMediaQuery("(max-width:960px");
  const { t } = useTranslation();
  const classes = useStyles({
      mediaQueryMd,
      mediaQueryLg,
    });

  const handleClose = () => setIsOpen(false);
  const handleOpen = () => setIsOpen(true);

  useEffect(() => {
    const title = t(`components.globalPopUp.title`);
    if (title !== "" && !is(POPE_PRAYER_EMBED)) {
      handleOpen();
    }
  }, [t])

  return (
    <Modal
      open={isOpen}
      closeAfterTransition
      BackdropComponent={Backdrop}
      BackdropProps={{
        timeout: 500,
      }}
      className={classes.loginModal}
      data-testid="main-content_modal"
      onClose={handleClose}
    >
      <Fade in={isOpen}>
        <div className={`${classes.contentLogin}`}>
          <div className={classes.authFormLogin}>
            <div className={classes.closeIconContent}>
              <Icon
                onClick={() => handleClose()}
                icon={IconClose}
                alt="close"
                id="ico_authForm_close_modal"
              />
            </div>
            <div className={classes.wrapperLogin}>
              <div className={classes.titleContent}>
                <h1 data-testid={`txt_title_authForm`}>
                  {t(`components.globalPopUp.title`)}
                </h1>
                <div className={classes.titleContentContainer}>
                  <p data-testid={`txt_description_authForm`}>
                    {t(
                      `components.globalPopUp.p1`
                    )}
                  </p>
                  <p data-testid={`txt_description_authForm`}>
                    {t(
                      `components.globalPopUp.p2`
                    )}
                  </p>
                  <p data-testid={`txt_description_authForm`}>
                    {t(
                      `components.globalPopUp.p3`
                    )}
                  </p>
                  <p data-testid={`txt_description_authForm`}>
                    {t(
                      `components.globalPopUp.p4`
                    )}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Fade>
    </Modal>
  );
}
